import React from 'react';
import Stack from '@mui/material/Stack';

import type { InterventionCenterStatistics as InterventionCenterStatisticsType } from '../../../common/types/statistics/fhbfStatistics';
import CaseStatistics from './CaseStatistics';
import CounselingStatistics from './CounselingStatistics';
import CounselingReasonStatistics from './CounselingReasonStatistics';
import RelationshipStatistics from './RelationshipStatistics';
import ReferralStatistics from './ReferralStatistics';
import AccompanimentStatistics from './AccompanimentStatistics';

type Props = {
  statistics: InterventionCenterStatisticsType;
};

function InterventionCenterStatistics({ statistics }: Props) {
  return (
    <Stack spacing={2}>
      <CaseStatistics statistics={statistics} />
      <CounselingStatistics statistics={statistics} />
      <CounselingReasonStatistics statistics={statistics} />
      <RelationshipStatistics statistics={statistics} />
      <ReferralStatistics statistics={statistics} />
      <AccompanimentStatistics statistics={statistics} />
    </Stack>
  );
}

export default InterventionCenterStatistics;
